import { ApiService } from "./apiService";
import {
  CheckInFilters,
  UserCheckIn,
  UserCheckInsApiResponse,
} from "../types/checkin";
import { unwrapPaginated } from "../utils/paginationHelper";
import { PaginatedResult } from "../types/api";
import { logger } from "../utils/logger";

export class CheckInService {
  static async getUserCheckIns(
    userId: number,
    page: number = 1,
    filters: CheckInFilters = {},
    perPage: number = 10
  ): Promise<PaginatedResult<UserCheckIn> | null> {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("per_page", perPage.toString());

      // An empty submitted_at fails the API's date_format rule
      if (filters.submitted_at) {
        params.append("submitted_at", filters.submitted_at);
      }

      const response = await ApiService.get(
        `/check-ins/user/${userId}/filter?${params.toString()}`
      );
      const result = await ApiService.handleResponse<UserCheckInsApiResponse>(
        response
      );

      return unwrapPaginated<UserCheckIn>(result, "check-ins");
    } catch (err: any) {
      logger.error("Error fetching user check-ins:", err);
      return null;
    }
  }
}
